module.exports = __webpack_public_path__ + "static/5-3a35a9730c526596293ae5970697e95b.jpg";